import axios from "axios";

const BACKEND_URL = window.location.origin;
export const VAIPEDE_API = `${BACKEND_URL}/api`;

// Instância axios isolada do produto VAI PEDE. Usa `vaipede_token`, evita bleed dos
// tokens do Compromisso Digital ou do CD Cotações.
export const vpAxios = axios.create({ baseURL: VAIPEDE_API });

vpAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("vaipede_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

vpAxios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const msg = err?.response?.data?.detail || "";
      if (/token|usu[aá]rio/i.test(String(msg))) {
        localStorage.removeItem("vaipede_token");
        localStorage.removeItem("vaipede_user");
        if (!window.location.pathname.startsWith("/vaipede/login") && !window.location.pathname.startsWith("/vaipede/cardapio")) {
          window.location.href = "/vaipede/login";
        }
      }
    }
    // HTTP 402 — trial expirado. Sinaliza para o Dashboard exibir o modal
    // "Assine um plano". Evita loops de toast em polls automáticos.
    if (err?.response?.status === 402) {
      try { window.dispatchEvent(new CustomEvent("vaipede:trial-expired", { detail: err.response.data })); } catch {}
    }
    // HTTP 403 com "Faça upgrade" (limite de plano). Sinaliza banner.
    if (err?.response?.status === 403 && /upgrade|limite/i.test(String(err?.response?.data?.detail || ""))) {
      try { window.dispatchEvent(new CustomEvent("vaipede:plano-bloqueado", { detail: err.response.data })); } catch {}
    }
    return Promise.reject(err);
  }
);

export const money = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** Baixa um PDF autenticado e tenta abrir automaticamente no visualizador do
 * sistema. Estratégia:
 *   1) Web Share API (mobile Android/iOS) → dispara a caixa "Abrir com..." nativa
 *   2) Fallback desktop → salva na pasta Downloads + abre nova aba com o PDF
 */
export async function downloadPdf(path, filename, tokenKey = "vaipede_token") {
  const token = localStorage.getItem(tokenKey);
  const resp = await fetch(`${VAIPEDE_API}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!resp.ok) throw new Error("erro ao baixar PDF");
  const blob = await resp.blob();
  const safeName = filename || "recibo.pdf";
  const file = new File([blob], safeName, { type: "application/pdf" });

  // --- Caminho 1 (mobile): Web Share API com arquivo ---
  // Dispara o mesmo diálogo "Abrir com..." dos 3 pontinhos do navegador
  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: safeName });
      return;
    }
  } catch (err) {
    // usuário cancelou — não é erro, mas seguimos para o fallback
    if (err && err.name === "AbortError") return;
  }

  // --- Caminho 2 (desktop / fallback): download + nova aba ---
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  try { window.open(url, "_blank", "noopener,noreferrer"); } catch {}
  setTimeout(() => URL.revokeObjectURL(url), 15000);
}
